module.exports = __webpack_public_path__ + "img/turbo_off.9c217fab.svg";